import GaugeWithNeedle from '../../../../../../../components/Charts/GaugeNeedle/GaugeWithNeedle'



export default function GetBrainGauge() {

  return (

      <GaugeWithNeedle realAge={57} chronologicalAge={62} />
    
  );
};




